require('../polly/presigner');



//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/lib/services/polly.js
// module id = 733
// module chunks = 29